import Grid from '@material-ui/core/Grid';
import { globalStyles } from '../../core/style/gstheme';
import { withStyles } from '@material-ui/core/styles';
import { UserConsumer } from '../../core/providers/UserProvider';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { ENTITLEMENTS } from '../../application-core/constants';
import { checkResourceEntitlements, getGraphFromProject } from '../utils/utils';
import FindProjectDialog from './FindProjectDialog';

// We expect a project managing component to be injected to allow for different types of associated project

const styles = () => {
    return Object.assign({
        aop: {
            marginRight: 30,
            padding: 12,
            backgroundColor: '#ffffff',
            borderRadius: 4,
            minHeight: 520
        },
        searchResults: {
            marginTop: 12
        }
    }, globalStyles);
};

class ManageAssociatedProject extends React.Component {

    onDeleteProjectAssociation = (id) => this.props.onDeleteProjectAssociation(id);

    render() {

        const { classes, data, onAddProjectAssociation, associatedProjectComponent, graph, lockedGraphs } = this.props;
        const AssociatedProject = associatedProjectComponent;

        const { defaultLang } = data;
        const isReadOnly = checkResourceEntitlements(data, ENTITLEMENTS.EDIT_TAXONOMY_PROJECT);

        return (
            <UserConsumer>
                {({ entitlements }) => (
                    !entitlements.includes(ENTITLEMENTS.VIEW_ONTOLOGY_PROJECT) ?
                        <Typography data-test="no-permissions" variant="body2">No permission to view ontology projects.</Typography>
                        :
                        <div className={classes.aop}>
                            <div data-test="search-filtering" className={classes.filterArea}>
                                <Grid container spacing={2} classes={
                                    {
                                        "spacing-xs-2": this.props.classes.fullGrid
                                    }
                                }>
                                    <Grid item xs={9}>
                                        <Typography className={classes.mainHeading} style={{ paddingTop: 0 }}>Associated Ontology Projects</Typography>
                                    </Grid>
                                    <Grid item xs={3} style={{textAlign: 'right'}}>
                                        {!isReadOnly &&
                                            <FindProjectDialog
                                                project={data.id}
                                                graph={getGraphFromProject(data.id)}
                                                onAddProject={onAddProjectAssociation}
                                                defaultLang={defaultLang}
                                            />
                                        }
                                    </Grid>
                                </Grid>
                            </div>
                            <div data-test="associated-projects" style={{ paddingBottom: 30 }}>
                                {data.ontologyProjectAssociation &&
                                    data.ontologyProjectAssociation.map((opa) =>
                                        <AssociatedProject
                                            key={opa}
                                            id={opa}
                                            lockedGraphs={lockedGraphs}
                                            graph={graph}
                                            defaultLang={defaultLang}
                                            onDeleteProject={this.onDeleteProjectAssociation}
                                        />
                                    )
                                }
                            </div>
                        </div>
                )}
            </UserConsumer>

        );
    }
}

ManageAssociatedProject.propTypes = {
    associatedProjectComponent: PropTypes.object.isRequired,
    onDeleteProjectAssociation: PropTypes.func.isRequired,
    onAddProjectAssociation: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    graph: PropTypes.string.isRequired,
    lockedGraphs: PropTypes.array,
};

export default withStyles(styles)(ManageAssociatedProject);